import { DateRangeFilter, TenantAndTeamFilter } from '../../Shared';
import { ApptTypeFilter } from '../ApptTypeFilter';
import { RescheduledFilter } from '../RescheduledFilter';
import { StatusFilter } from '../StatusFilter';
import { TeamFilter } from '../TeamFilter';

export const FiltersPanel = ({
  isAdmin,
  isManager,
  isManagerTeamLoading,
  isManagerTeamError,
  filters,
  onChangeFilters,
  managerTeam,
}) => {
  return (
    <>
      {isAdmin && (
        <TenantAndTeamFilter
          callerIds={filters.callerIds}
          onChangeCallerIds={onChangeFilters}
        />
      )}
      {isManager && !isManagerTeamError && (
        <TeamFilter
          callerIds={filters.callerIds}
          onChangeCallerIds={onChangeFilters}
          managerTeam={managerTeam}
          isManagerTeamLoading={isManagerTeamLoading}
        />
      )}
      <DateRangeFilter
        startDate={filters.startDate}
        endDate={filters.endDate}
        onChangeDateRange={onChangeFilters}
      />
      <StatusFilter
        statuses={filters.statuses}
        onChangeStatuses={onChangeFilters}
      />
      <RescheduledFilter
        isRescheduled={filters.isRescheduled}
        toggleIsRescheduled={onChangeFilters}
      />
      {!isAdmin && (
        <ApptTypeFilter
          apptType={filters.apptType}
          onChangeApptType={onChangeFilters}
        />
      )}
    </>
  );
};
